import { query, request } from 'src/utils/request';

// 获取单据类型下拉
export const getFormType = async params => {
  return query('/zlb/api/search/common/form-business-definition/form-type-support', {
    params,
  });
};

// 获取场景类型下拉
export const getSceneTypeList = async data => {
  return query('/zlb/api/search/common/form-business-definition/scene-support', {
    method: 'POST',
    data,
  });
};

// 运营侧-获取场景类型下拉
export const getOperatorSceneTypeList = async data => {
  return query('/zlb/api/search/common/operator/form-business-definition/scene-support', {
    method: 'POST',
    data,
  });
};

// 获取可创建场景类型
export const getCreateSceneType = async data => {
  return query('/zlb/api/search/common/form-business-definition/form-create-support', {
    method: 'POST',
    data,
  });
};

// web单据列表
export const getWebForm = async data => {
  return query('/zlb/api/search/page/web/form', {
    method: 'POST',
    data,
  });
};
// 采购单单据列表
export const getPurchaseForm = async data => {
  return query('/zlb/api/search/page/web/purchase-order-form', {
    method: 'POST',
    data,
  });
};
// web审核列表
export const getWebFormAudit = async data => {
  return query('/zlb/api/search/page/web/form-audit', {
    method: 'POST',
    data,
  });
};

// web财务列表
export const getWebFormFinance = async data => {
  return query('/zlb/api/search/page/web/form-finance', {
    method: 'POST',
    data,
  });
};

// web出纳列表
export const getWebFormCashier = async data => {
  return query('/zlb/api/search/page/web/form-cashier', {
    method: 'POST',
    data,
  });
};

// web运营列表
export const getWebFormOperate = async data => {
  return query('/zlb/api/search/page/web/form-operate', {
    method: 'POST',
    data,
  });
};
// 采购
export const getWebFormPurchase = async data => {
  return query('/zlb/api/search/page/web/form-purchase', {
    method: 'POST',
    data,
  });
};

// 删除申请单
export const removeApply = async formCode => {
  return query(`/zlb/api/expense/apply-form/delete/${formCode}`, {
    method: 'POST',
  });
};

// 删除报销单
export const removeClaim = async formCode => {
  return query(`/zlb/api/expense/expense-form/delete/${formCode}`, {
    method: 'POST',
  });
};

// 删除收入
export const removeIncome = async data => {
  return query('/zlb/budget/api/income/apply-form/delete', {
    data,
    method: 'POST',
  });
};

// 删除工资申报单
export const removeSalary = async data => {
  return query('/zlb/api/expense/wage/apply/delete', {
    data,
    method: 'POST',
  });
};

export const removeOvertime = async data => {
  return query('/zlb/api/expense/overtime/pay-form/delete', {
    data,
    method: 'POST',
  });
};

// 查询单位列表（运营使用）
export const getOperationOrgList = async params => {
  return query('/zlb/api/expense/org/relation/manage/queryInstitutionDeleted', {
    params,
  });
};

// 部门列表查询
export const getDeptList = () => {
  return query('/api/zlbuser/institution/departs');
};

// 接excel导出任务
export const exportExcel = async data => {
  return query('/zlb/api/search/common/export', {
    data,
    method: 'POST',
  });
};

// 报销单出纳结算列表-批量发起支付
export async function applyPay(data) {
  return request('/zlb/api/expense/expense-form/batch-apply-pay', { method: 'POST', data });
}
// 报销单出纳结算列表-同步支付结果
export async function syncPaymentResults(data) {
  return request('/zlb/api/pay/finance/synPayResult', { method: 'POST', data });
}

// 报销单运营侧列表-同步支付结果
export async function syncPaymentResultsForOperation(data) {
  return request('/zlb/api/pay/finance/syn-pay-result', { method: 'POST', data });
}

// 驳回报销单
export async function rejectExpenseForm(data) {
  return request('/zlb/api/expense/expense-form/reject', { method: 'POST', data });
}

export const getBaidaPrintContext = async params => {
  return query('/zlb/api/mbp/baida/print/get-context', {
    params,
  });
};

export const getBaidaPrintConfig = async params => {
  return query('/zlb/api/mbp/baida/print/get-config', {
    params,
  });
};

// 会议培训下钻页数据
export const getSceneDetailCharts = async params => {
  return query('/zlb/api/search/workbench/purchasePlatform/purchase-drill-down', {
    params,
  });
};

// 设置/取消无需报销
export const setNeedExpense = async data => {
  return query('/zlb/api/expense/common/need-expense', {
    data,
    method: 'POST',
  });
};

export const deleteOtherFundsForm = async data => {
  return query('/zlb/api/expense/rest/delete', {
    data,
    method: 'POST',
  });
};
export const searchCommonQueryFilterConfig = async data => {
  return query('/zlb/api/search/common/query-filter-config', {
    data,
    method: 'POST',
  });
};
// 归档打印查询
export const getWebFormReimburse = async data => {
  return query('/zlb/api/sop/paperless/print/form-list', {
    method: 'POST',
    data,
  });
};
// 附件查询
export const queryAttachmentList = async data => {
  return query('/zlb/api/sop/paperless/print/attachment-list', {
    method: 'POST',
    data,
  });
};
// 场景类型查询
export const queryScenarioTypeList = async data => {
  return query('/zlb/api/sop/paperless/print/support-scene', {
    method: 'POST',
    data,
  });
};

// 线下支付
export const submitOfflinePay = async data => {
  return query('/zlb/api/pay/order/offline', {
    method: 'POST',
    data,
  });
};

// 获取实物签收列表
export const getArchiveAttachmentList = async data => {
  return query('/zlb/api/archive/attachment/receipt/list', {
    method: 'POST',
    data,
  });
};
// 修改稿本类型
export const updateAttachmentManuscriptType = async data => {
  return query('/zlb/api/archive/attachment/update-manuscript-type', {
    method: 'POST',
    data,
  });
};
// 修改签收状态
export const updateAttachmentReceiptStatus = async data => {
  return request('/zlb/api/archive/attachment/receipt/batch-update-receipt-status', {
    method: 'POST',
    data,
  });
};
// 获取银行回单
export const getBankReceiptList = async params => {
  return query('/zlb/api/pay/bank/receipt/file-list-by-form-code', {
    method: 'get',
    params,
  });
};

// 获取收款单收款人列表
export const getFormReceiverList = async data => {
  return query('/zlb/api/pay/order/batch/cashier/info', {
    method: 'POST',
    data,
  });
};

// 获取退款通知书列表
export const getRefundNoticeList = async params => {
  return query('/zlb/api/pay/order/return/info', {
    method: 'get',
    params,
  });
};

// web租户列表
export const getWebFormTenant = async data => {
  return query('/zlb/api/search/page/web/form-tenant', {
    method: 'POST',
    data,
  });
};

// 经济分类列表
export const getEconomicsSubjectList = async data => {
  return query('/zlb/budget/manage/query-economy-classify', {
    method: 'POST',
    data,
  });
};
